import { MaybeRef } from 'vue';
import vtkPolyData from '@kitware/vtk.js/Common/DataModel/PolyData';
import vtkActor from '@kitware/vtk.js/Rendering/Core/Actor';
import vtkMapper from '@kitware/vtk.js/Rendering/Core/Mapper';
import { useVtkRepresentation } from '@/src/core/vtk/useVtkRepresentation';
import { Maybe } from '@/src/types';
import { View } from '@/src/core/vtk/types';

export function useGeometryRepresentation(
  view: View,
  polyData: MaybeRef<Maybe<vtkPolyData>>
) {
  const geomRep = useVtkRepresentation({
    view,
    data: polyData,
    vtkActorClass: vtkActor,
    vtkMapperClass: vtkMapper,
  });

  return geomRep;
}
